import React from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../../context/WishlistContext';
import ProductCard from '../../components/user/ProductCard';

export default function Wishlist() {
  const { wishlist } = useWishlist();

  if (wishlist.length === 0) {
    return (
      <div className="bg-[#FAF8F5] min-h-screen py-24 text-[#2B1810]">
        <div className="max-w-md mx-auto px-4 text-center space-y-4">
          <div className="w-16 h-16 rounded-full bg-[#F5EFEB] flex items-center justify-center text-[#C49A45] mx-auto border border-[#E8DFD8]">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            </svg>
          </div>
          <h2 className="font-heading text-2xl font-bold text-[#2B1810]">Your Wishlist is Empty</h2>
          <p className="text-xs text-[#8A796C]">Save your favorite authentic sandalwood idols, malas, bracelets & agarbatti to view anytime.</p>
          <div>
            <Link to="/shop" className="bg-[#C49A45] hover:bg-[#B08736] text-white font-bold text-xs uppercase tracking-widest px-8 py-3 rounded shadow transition-colors inline-block">
              EXPLORE CATALOG
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810] py-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h1 className="font-heading text-3xl font-bold text-[#2B1810]">
            My Wishlist ({wishlist.length})
          </h1>
          <div className="flex items-center justify-center gap-3 mt-2">
            <span className="h-[1px] w-12 bg-[#C49A45]"></span>
            <span className="text-[#C49A45] text-lg">♡</span>
            <span className="h-[1px] w-12 bg-[#C49A45]"></span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {wishlist.map((product) => (
            <ProductCard key={product._id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
}
